import { Spinner } from '@components/Spinner/Spinner'

import { StyledFullScreenLoaderContainer } from './styles'

export const FullScreenLoader = () => {
  return (
    <StyledFullScreenLoaderContainer>
      <Spinner />
    </StyledFullScreenLoaderContainer>
  )
}
